import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

interface ForcedChangePasswordGateProps {
  children: React.ReactNode;
}

// Feature 011 (FR-049, FR-032) — every authenticated child route is bounced
// to /change-password while the user owes a first-login change. The
// /change-password route itself is rendered without this gate so the user
// can break out of the lock.
export function ForcedChangePasswordGate({ children }: ForcedChangePasswordGateProps) {
  const { mustChangePassword, isAuthenticated } = useAuth();
  const location = useLocation();

  if (
    isAuthenticated &&
    mustChangePassword &&
    location.pathname !== '/change-password'
  ) {
    return <Navigate to="/change-password" replace />;
  }

  return <>{children}</>;
}
